export default () => {
  return [
    { label: 'State holiday', value: 'State holiday' },
    { label: 'Religious holiday', value: 'Religious holiday' },
    { label: 'Collective vacation', value: 'Collective vacation' },
  ];
};
